                                                                                                                                           import React from 'react';

import AccordionItem from '@elements/AccordionItem';

type ItemListProps = {
  id: string,
  description: string,
  title: string,
  cta: string,
  ctaHref: string,
  ctaText: string,
  ctaColor: string,
};

type AccordionsProps = {
  item: ItemListProps[],
};

const Accordions = ({
  item: itemsList,
}: AccordionsProps): JSX.Element => (
  <div className="accordions--main">
    {
      itemsList?.map( (item) => (
        <AccordionItem
          key={item.id}
          description={item.description}
          title={item.title}
          cta={item.cta}
          ctaHref={item.ctaHref}
          ctaText={item.ctaText}
          ctaColor={item.ctaColor}
        />
      ))
    }
  </div>
);

export default Accordions;
